import { render, staticRenderFns } from "./EditFloorplanButtons.vue?vue&type=template&id=0008d530"
import script from "./EditFloorplanButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditFloorplanButtons.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EditFloorplanButtons.vue?vue&type=style&index=0&id=0008d530&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports